import { callAccountMe, defaults } from '@/api'
import { getApiErrorStatus } from '@/utils/apiError'

/**
 * Une session « en tant que » se ferme aussi ailleurs : « Terminer » dans un autre onglet, nouvelle session
 * ouverte depuis la console, échéance. La gateway refuse alors le jeton (401). Elle répond aussi 401 à des
 * refus métier (rôle, propriétaire d'un flux) : seul `/account/me`, ouvert à tout membre, dit si la session
 * tient encore. Couvre les appels du client généré, qui passent tous par `defaults.fetch`.
 */
export const watchImpersonationRefusal = (
  onRefused: () => void
): (() => void) => {
  const previous = defaults.fetch
  const send: typeof fetch = previous ?? ((input, init) => fetch(input, init))
  let checking = false

  defaults.fetch = async (input, init) => {
    const response = await send(input, init)
    if (response.status === 401 && !checking) {
      checking = true
      callAccountMe({ fetch: send }).then(
        () => {
          checking = false
        },
        (error: unknown) => {
          // Refus confirmé compris : l'onglet peut reprendre la session suivante, dont la fin doit encore se voir.
          checking = false
          if (getApiErrorStatus(error) === 401) onRefused()
        }
      )
    }
    return response
  }

  return () => {
    defaults.fetch = previous
  }
}
